// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"53e240c0","154":"61919740","548":"504e3aea","915":"cc949e18","993":"a6d77847"}[chunkId] + ".chunk.css";
};